import { useEffect } from "react";
import type { ThemeConfig } from "@/features/auth/types/organization.type";
import { applyBrandColors, resetBrandColors } from "@/shared/utils/brandColors";

export const useBrandColors = (themeConfig: ThemeConfig | null | undefined): void => {
  useEffect(() => {
    if (!themeConfig?.colors) {
      resetBrandColors();
      return;
    }

    applyBrandColors(themeConfig);

    return () => resetBrandColors();
  }, [JSON.stringify(themeConfig)]);
};
